"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = __importDefault(require("vue"));
const LoadingSpinner_vue_1 = __importDefault(require("../loading/LoadingSpinner.vue"));
const NotiTabs_vue_1 = __importDefault(require("./NotiTabs.vue"));
const NotiList_vue_1 = __importDefault(require("./NotiList.vue"));
const NotiItemDetail_vue_1 = __importDefault(require("./NotiItemDetail.vue"));
const NotiTabs_1 = require("../../../containers/notification/NotiTabs");
const GameConst_1 = require("../../../constants/GameConst");
exports.default = vue_1.default.extend({
    components: {
        LoadingSpinner: LoadingSpinner_vue_1.default,
        NotiTabs: NotiTabs_vue_1.default,
        NotiList: NotiList_vue_1.default,
        NotiItemDetail: NotiItemDetail_vue_1.default,
    },
    data() {
        return {
            noticeImageUrl: 'url(images/information/img_information.png)',
            middleFrameUrl: 'url(images/game/common/repeat/img_repeatDecorationModal.png)',
            bottomFrameUrl: 'url(images/game/common/img_commonObject.png)',
            oldTab: NotiTabs_1.NotiTabType.All,
            currentTab: NotiTabs_1.NotiTabType.All,
        };
    },
    watch: {
        currentItemDetail(newVal) {
            if (newVal) {
                this.oldTab = this.currentTab;
                if (newVal.categoryEnName === GameConst_1.NotiLabelType.Release ||
                    newVal.categoryEnName === GameConst_1.NotiLabelType.Event) {
                    this.currentTab = NotiTabs_1.NotiTabType.Update;
                }
                else {
                    this.currentTab = NotiTabs_1.NotiTabType.Other;
                }
            }
            else {
                this.currentTab = this.oldTab;
            }
        },
    },
    computed: {
        notiData() {
            return this.$store.state.notiData;
        },
        currentItemDetail() {
            return this.$store.state.currentItemDetail;
        },
        currentTabData() {
            let notiData = [];
            switch (this.currentTab) {
                case NotiTabs_1.NotiTabType.All:
                    notiData = this.notiData;
                    break;
                case NotiTabs_1.NotiTabType.Update:
                    notiData = this.notiData.filter((n) => n.categoryEnName === GameConst_1.NotiLabelType.Release ||
                        n.categoryEnName === GameConst_1.NotiLabelType.Event);
                    break;
                case NotiTabs_1.NotiTabType.Other:
                    notiData = this.notiData.filter((n) => n.categoryEnName === GameConst_1.NotiLabelType.Normal ||
                        n.categoryEnName === GameConst_1.NotiLabelType.Maintenance);
                    break;
            }
            return notiData;
        },
    },
    methods: {
        closeModal() {
            this.$store.commit('setItemDetail', null);
            this.$store.commit('showComponent', {
                component: 'notificationModal',
                isShow: false,
            });
        },
        handleResponsive() {
            const modalWidth = this.$refs.modal.clientWidth;
            // Custom modal frame
            this.$refs.topFrame.style.transform = `scale(${modalWidth * 0.00145})`;
            this.$refs.bottomFrame.style.transform = `scale(${modalWidth * 0.00145})`;
            // Custom title image
            this.$refs.title.style.transform = `translateY(-50%) scale(${modalWidth * 0.0016})`;
            // Custom border of content
            this.$refs.content.style.borderWidth = `${modalWidth * 0.008}px`;
        },
        changeTab(targetTab) {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.$store.commit('setItemDetail', null);
                this.currentTab = targetTab;
            });
        },
    },
    created() {
        if (!this.notiData) {
            this.$store.dispatch('getAllNotice').then(() => {
                this.handleResponsive();
            });
        }
    },
    mounted() {
        if (this.notiData) {
            this.handleResponsive();
        }
        window.addEventListener('resize', this.handleResponsive);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResponsive);
    },
});
